import React from 'react';
import { Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import _ from 'lodash';

export const LOGICAL_DELETED_TEXT = 'Expediente Tradicional';
export const LOGICAL_DELETED_ROW_CLASS = 'row-logical-deleted';
export const FORBIDDEN_EXPEDIENT_MESSAGE = 'No tienes permiso para ver este expediente';
export const FORBIDDEN_EXPEDIENT_REDIRECT_PATH = '/my_expedients';

export const isLogicalDeleted = (item) => _.get(item, 'logical_deleted') === true;

export const getLogicalDeletedRowClass = (row) =>
  isLogicalDeleted(row) ? LOGICAL_DELETED_ROW_CLASS : '';

// Agrega el tooltip a todas las celdas de las filas con expediente tradicional
export const getColumnsWithLogicalDeletedTooltip = (columns = []) =>
  columns.map((column) => ({
    ...column,
    attrs: (cell, row, rowIndex, colIndex) => {
      const columnAttrs =
        typeof column.attrs === 'function'
          ? column.attrs(cell, row, rowIndex, colIndex)
          : column.attrs || {};
      return isLogicalDeleted(row) ? { ...columnAttrs, title: LOGICAL_DELETED_TEXT } : columnAttrs;
    },
  }));

export const ExpedientNumberLink = ({ logicalDeleted = false, to, children, ...restOfProps }) => {
  if (logicalDeleted) {
    return (
      <span className="expedient-number-logical-deleted" title={LOGICAL_DELETED_TEXT}>
        <i className="fas fa-ban" aria-hidden="true" /> {children} <small>(Tradicional)</small>
      </span>
    );
  }

  return (
    <Link to={to} {...restOfProps}>
      {children}
    </Link>
  );
};

export const isForbiddenExpedientResponse = (response) => _.get(response, 'code') === 403;

let forbiddenRedirectTimeout = null;
let forbiddenRedirectHistory = null;

// Varias peticiones del mismo expediente pueden responder 403 a la vez; solo se notifica y redirige una vez
export const redirectFromForbiddenExpedient = (history) => {
  if (history && typeof history.push === 'function') {
    forbiddenRedirectHistory = history;
  }
  if (forbiddenRedirectTimeout) return;

  NotificationManager.error(FORBIDDEN_EXPEDIENT_MESSAGE, '', 3000);

  forbiddenRedirectTimeout = setTimeout(() => {
    const redirectHistory = forbiddenRedirectHistory;
    forbiddenRedirectTimeout = null;
    forbiddenRedirectHistory = null;

    if (redirectHistory) {
      redirectHistory.push(FORBIDDEN_EXPEDIENT_REDIRECT_PATH);
      return;
    }
    window.location.href = FORBIDDEN_EXPEDIENT_REDIRECT_PATH;
  }, 3001);
};
